import { render } from "./FileColFullDisplayBatch.vue?vue&type=template&id=0b215eac"
import script from "./FileColFullDisplayBatch.vue?vue&type=script&lang=js"
export * from "./FileColFullDisplayBatch.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__